<template lang="pug">
    .settings(v-if='settings')
        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}:
            | {{ settings.showTime + ' ' + $i18n.t('trainer.trainer_gameFormSettingValue_seconds')}}

        div
            | {{ $i18n.t('progress.progress_preview_timeLimit') }}:
            | {{ settings.timeLimit + ' ' + $i18n.t('trainer.trainer_gameFormSettingValue_minutes')}}

        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_simultaneously') }}:
            | {{ settings.simultaneously ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}

        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_differentFigures') }}:
            | {{ settings.differentFigures ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}

        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}:
            | {{ settings.isMusicOn ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            withIcon: Boolean,
        },
    };
</script>
